const Backbone = require('backbone');
const dustjs = require('dustjs');
const _pricedOptionAssociatedProductModalDust = require('store/global/pages/products/_priced_option_associated_product_modal.dust');

module.exports = Backbone.View.extend({
	render: function() {
		dustjs.render(_pricedOptionAssociatedProductModalDust, this.model.attributes, (error, markup) => {
			if (error) {
				window.clientErrorHandler(error);
			} else {
				if (this.modal) {
					this.modal.remove();
				}
				this.modal = $(markup);
				this.modal.appendTo('body');
				this.modal.modal('show');
			}
		});
	}
});
